<template>
  <div class="child-wrapper">
    <BalletAndDance v-if="catId==='ballet-dance'"></BalletAndDance>
    <ChildrenFamily v-if="catId==='children-family'"></ChildrenFamily>
    <ClassicalMusic v-if="catId==='classical-music'"></ClassicalMusic>
    <FestivalsMultiCategory v-if="catId==='festivals-multi-category'"></FestivalsMultiCategory>
    <FestivalsSingleCategory v-if="catId==='festivals-single-category'"></FestivalsSingleCategory>
    <MusicalTheatre v-if="catId==='musical-theatre'"></MusicalTheatre>
    <ContemporaryMusic v-if="catId==='contemporary-music'"></ContemporaryMusic>
    <Opera v-if="catId==='opera'"></Opera>
    <SpecialEvents v-if="catId==='special-events'"></SpecialEvents>
    <Theatre v-if="catId==='theatre'"></Theatre>
    <CircusPhysicalTheatre v-if="catId==='circus-physical-theatre'"></CircusPhysicalTheatre>
    <Comedy v-if="catId==='comedy'"></Comedy>
  </div>
</template>

<script>
import BalletAndDance from './BalletAndDance'
import ChildrenFamily from './ChildrenFamily'
import ClassicalMusic from './ClassicalMusic'
import FestivalsMultiCategory from './FestivalsMultiCategory'
import FestivalsSingleCategory from './FestivalsSingleCategory'
import MusicalTheatre from './MusicalTheatre'
import ContemporaryMusic from './ContemporaryMusic'
import Opera from './Opera'
import SpecialEvents from './SpecialEvents'
import Theatre from './Theatre'
import CircusPhysicalTheatre from './CircusPhysicalTheatre'
import Comedy from './Comedy'

export default {
  components: {
    BalletAndDance,
    ChildrenFamily,
    ClassicalMusic,
    FestivalsMultiCategory,
    FestivalsSingleCategory,
    MusicalTheatre,
    ContemporaryMusic,
    Opera,
    SpecialEvents,
    Theatre,
    CircusPhysicalTheatre,
    Comedy
  },
  data () {
    return {
    }
  },
  props: ['catId'],
  mounted () {
  },
  methods: {
  }
}
</script>
